export class NotAuthenticatedError extends Error {
  NotAuthenticatedError(message) {
    this.super(message)
  }
}
